import PickQueue from 'pages/PickQueue';
import RegisterQueue from 'pages/RegisterQueue';
import { useRoutes } from "react-router-dom";

import HomePage from './pages/HomePage';
import Phlebotomy from 'pages/Phlebotomy';
import { PoliQueue } from 'pages/PoliQueue';

/**
 * 
 * @return {React.Component} return routing of element
 */
function App() {
  return useRoutes([
    {path: "", element: (<HomePage />)},
    {path: "display", children: [
      {path: "pick", element: (<PickQueue />) },
      {path: "register", element: (<RegisterQueue withFcm={false} />) },
      {path: "register-fcm", element: (<RegisterQueue withFcm={true} />) },
      {path: 'phlebotomy', element: (<Phlebotomy />)},
      {path: 'poli', element: (<PoliQueue />)}
    ]}
  ])
}
export default App;